import track from 'react-tracking';
import { RouterLink } from '@redux-first-router-link';
import {
  CompetitorWrapper,
  CompetitorSnowflake,
  CompetitorDetails,
} from './styled';
import loadable from '@loadable/component';

const Snowflake = loadable(() => import('@simplywallst/ui-charts/Snowflake'), {
  resolveComponent: (components) => components.Snowflake,
  ssr: false,
});

const SnowflakeDotMarkers = loadable(
  () => import('@simplywallst/ui-charts/Snowflake/components/DotMarkers'),
  {
    resolveComponent: (components) => components.DotMarkers,
    ssr: false,
  }
);
export type CompetitorProps = {
  points: [number, number, number, number, number];
  index: number;
  companyId: string;
  uniqueSymbol: string;
  companyName: string;
  canonicalUrl: string;
};

const Competitor = ({
  index,
  points,
  companyId,
  companyName,
  uniqueSymbol,
  canonicalUrl,
  tracking: { trackEvent },
}: Tracking & CompetitorProps) => (
  <CompetitorWrapper>
    <RouterLink
      inheritColor
      noUnderline
      to={canonicalUrl}
      onClick={() =>
        trackEvent({
          index,
          uniqueSymbol,
          companyId,
        })
      }
    >
      <CompetitorSnowflake>
        <Snowflake points={points}>
          <SnowflakeDotMarkers />
        </Snowflake>
      </CompetitorSnowflake>
      <CompetitorDetails>
        <p>{companyName}</p>
        <h4>{uniqueSymbol}</h4>
      </CompetitorDetails>
    </RouterLink>
  </CompetitorWrapper>
);

export default track({
  action: 'click',
})(Competitor);
